import React from "react";
import { TimerIcon } from "lucide-react";
import { useOfferClock } from "../hooks/useOfferClock";
type CountdownProps = {
  tone?: "dark" | "light";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useOfferClock();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const dark = tone === "dark";
  return <div className="w-full" role="timer" aria-live="off" data-id="element-99" data-mp="3c3z1iz9ad2ct">
      <p className={`mb-3 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-gold-300" : "text-brand-700"}`} data-id="element-100" data-mp="3h20fx6vrodhy">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="371zxdn5q21et" />
        Special offer ends in
      </p>
      <div className="flex items-start justify-center gap-2 sm:gap-3" data-id="element-102" data-mp="10c3gnqivjy44">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-103" data-mp="15add04gc54rb" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-104" data-mp="15929m5qsxz0q">
              <span className={`flex h-16 w-[4.5rem] items-center justify-center rounded-xl text-3xl font-extrabold tabular-nums sm:h-20 sm:w-24 sm:text-4xl ${dark ? "bg-white text-brand-900" : "bg-brand-900 text-white"}`} data-id="element-105" data-mp="xzvipeo9v61p">
                {String(unit.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase tracking-wide ${dark ? "text-brand-200" : "text-muted"}`} data-id="element-106" data-mp="f22hqhx7l66y">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 text-3xl font-extrabold sm:pt-5 ${dark ? "text-white/70" : "text-brand-300"}`} aria-hidden="true" data-id="element-107" data-mp="k0vs41h78h2w">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}